import ErrorBoundary from '../ErrorBoundary';
import PurchaseMotionButton from '../_core/purchaseMotions/PurchaseMotionButton';
import { jsx as _jsx } from "react/jsx-runtime";
const UIPurchaseMotionButtonWithErrorBoundary = props => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "purchaseMotionButton",
    children: /*#__PURE__*/_jsx(PurchaseMotionButton, Object.assign({}, props))
  });
};
export default UIPurchaseMotionButtonWithErrorBoundary;